// extracted by mini-css-extract-plugin
export default {"message":"SecondaryContactForm_message__DN8ec"};